import { GQLFooterFragment } from '@theprintbar/graphql';
import { RichText } from '@theprintbar/ui';
import { HTMLAttributes } from 'react';

interface MoreProps extends HTMLAttributes<HTMLDivElement> {
	data: GQLFooterFragment;
}

export function BusinessDetails({ data, ...props }: MoreProps) {
	return (
		<div {...props} className="space-y-4">
			<h5 className="font-belfast font-bold text-xs uppercase">{data.businessDetailsTitle}</h5>
			<div className="flex flex-col font-normal text-sm md:text-base">
				<RichText className="space-y-2.5 whitespace-pre-line" content={data.businessDetailsText} />
			</div>
		</div>
	);
}
